import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "deliveryDate", "dayButton", "hiddenInputs"]

  connect() {
    this.selectedDates = new Set()
    // Initialize from existing hidden inputs
    this.hiddenInputsTarget.querySelectorAll('input[name="consumption_dates[]"]').forEach(input => {
      this.selectedDates.add(input.value)
    })
  }

  toggleDay(event) {
    event.preventDefault()
    const button = event.currentTarget
    const date = button.dataset.date

    if (this.selectedDates.has(date)) {
      this.selectedDates.delete(date)
      button.classList.remove('btn-primary')
      button.classList.add('btn-outline-secondary')
    } else {
      this.selectedDates.add(date)
      button.classList.remove('btn-outline-secondary')
      button.classList.add('btn-primary')
    }

    this.submitForm()
  }

  deliveryDateChanged() {
    // Clear selections and submit to reload with new date range
    this.selectedDates.clear()
    this.syncHiddenInputs()
    this.formTarget.submit()
  }

  presetFriday() {
    this.applyPreset(5, [1, 2, 3, 4]) // Friday: Sat, Sun, Mon, Tue
  }

  presetTuesday() {
    this.applyPreset(2, [1, 2, 3]) // Tuesday: Wed, Thu, Fri
  }

  applyPreset(dayOfWeek, offsets) {
    const today = new Date()
    const deliveryDate = this.nextWeekday(today, dayOfWeek)
    this.deliveryDateTarget.value = this.formatDate(deliveryDate)

    this.selectedDates.clear()
    offsets.forEach(offset => {
      const d = new Date(deliveryDate)
      d.setDate(d.getDate() + offset)
      this.selectedDates.add(this.formatDate(d))
    })

    this.syncHiddenInputs()
    this.formTarget.submit()
  }

  submitForm() {
    this.syncHiddenInputs()
    this.formTarget.submit()
  }

  syncHiddenInputs() {
    const container = this.hiddenInputsTarget
    container.innerHTML = ''
    this.selectedDates.forEach(date => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'consumption_dates[]'
      input.value = date
      container.appendChild(input)
    })
  }

  nextWeekday(fromDate, dayOfWeek) {
    const date = new Date(fromDate)
    const currentDay = date.getDay()
    let daysUntil = dayOfWeek - currentDay
    if (daysUntil <= 0) daysUntil += 7
    date.setDate(date.getDate() + daysUntil)
    return date
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}
